var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimedealicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 91,
    viewBox: "0 0 72 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.745 86H3.782V78.356H1.26V76.718H8.267V78.356H5.745V86ZM12.8443 86H8.61932V84.882L9.75032 84.362V78.356L8.61932 77.836V76.718H12.8443V77.836L11.7133 78.356V84.362L12.8443 84.882V86ZM18.0271 86L15.7911 78.72H15.7391C15.7477 78.8933 15.7607 79.1533 15.7781 79.5C15.7954 79.8467 15.8127 80.2193 15.8301 80.618C15.8474 81.008 15.8561 81.3633 15.8561 81.684V86H14.1011V76.718H16.7791L18.9761 83.816H19.0151L21.3421 76.718H24.0201V86H22.1871V81.606C22.1871 81.3113 22.1914 80.9733 22.2001 80.592C22.2174 80.2107 22.2304 79.851 22.2391 79.513C22.2564 79.1663 22.2694 78.9063 22.2781 78.733H22.2261L19.8341 86H18.0271ZM31.3827 86H26.0397V76.718H31.3827V78.33H28.0027V80.371H31.1487V81.983H28.0027V84.375H31.3827V86ZM43.7371 81.268C43.7371 82.308 43.5378 83.179 43.1391 83.881C42.7404 84.583 42.1598 85.1117 41.3971 85.467C40.6431 85.8223 39.7331 86 38.6671 86H36.0411V76.718H38.9531C39.9238 76.718 40.7644 76.8913 41.4751 77.238C42.1944 77.5847 42.7491 78.096 43.1391 78.772C43.5378 79.4393 43.7371 80.2713 43.7371 81.268ZM41.6961 81.32C41.6961 80.6353 41.5964 80.072 41.3971 79.63C41.1978 79.188 40.8988 78.863 40.5001 78.655C40.1101 78.4383 39.6291 78.33 39.0571 78.33H38.0041V84.375H38.8491C39.8111 84.375 40.5261 84.1193 40.9941 83.608C41.4621 83.0967 41.6961 82.334 41.6961 81.32ZM50.6821 86H45.3391V76.718H50.6821V78.33H47.3021V80.371H50.4481V81.983H47.3021V84.375H50.6821V86ZM57.9696 86L57.2936 83.79H53.9136L53.2376 86H51.1186L54.3946 76.679H56.7996L60.0886 86H57.9696ZM56.1496 79.981C56.1062 79.8337 56.0499 79.6473 55.9806 79.422C55.9112 79.1967 55.8419 78.967 55.7726 78.733C55.7032 78.499 55.6469 78.2953 55.6036 78.122C55.5602 78.2953 55.4996 78.512 55.4216 78.772C55.3522 79.0233 55.2829 79.266 55.2136 79.5C55.1529 79.7253 55.1052 79.8857 55.0706 79.981L54.4076 82.139H56.8256L56.1496 79.981ZM60.9391 86V76.718H62.9021V84.375H66.6721V86H60.9391Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6122 54.009C44.9578 54.009 52.5339 46.6259 52.5339 37.5183C52.5339 28.4107 44.9578 21.0276 35.6122 21.0276C26.2666 21.0276 18.6904 28.4107 18.6904 37.5183C18.6904 46.6259 26.2666 54.009 35.6122 54.009Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6122 49.3902C42.3403 49.3902 47.7945 44.0749 47.7945 37.5182C47.7945 30.9615 42.3403 25.6462 35.6122 25.6462C28.8841 25.6462 23.4299 30.9615 23.4299 37.5182C23.4299 44.0749 28.8841 49.3902 35.6122 49.3902Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.736 17.6959C26.3838 16.5493 24.6359 15.9447 22.8445 16.004C21.053 16.0633 19.3513 16.7822 18.0821 18.0156C16.8129 19.2491 16.0706 20.9055 16.0048 22.6511C15.939 24.3968 16.5545 26.1018 17.7274 27.4227L27.736 17.6959Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8658 22.6766L24.7781 24.5402",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0051 16.9652L18.1401 18.0713",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4884 17.6959C44.8406 16.5493 46.5885 15.9447 48.3799 16.004C50.1714 16.0633 51.8731 16.7822 53.1423 18.0156C54.4116 19.2491 55.1538 20.9055 55.2196 22.6511C55.2854 24.3968 54.6699 26.1018 53.497 27.4227L43.4884 17.6959Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3653 22.6766L46.4462 24.5402",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2261 16.9652L53.0911 18.0713",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5107 55.1083L24.7782 50.6035",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7136 55.1083L46.4462 50.6035",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6122 38.8388C36.3606 38.8388 36.9673 38.2476 36.9673 37.5182C36.9673 36.7889 36.3606 36.1976 35.6122 36.1976C34.8638 36.1976 34.2571 36.7889 34.2571 37.5182C34.2571 38.2476 34.8638 38.8388 35.6122 38.8388Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9673 37.5182H42.5735",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6122 36.1977V28.0529",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimedealicon);
export default __webpack_public_path__ + "static/media/timedealicon.b93051ca87cf089852fd3b6db5c7f27e.svg";
export { ForwardRef as ReactComponent };